import { isEqual, omit, pick } from "lodash";
import { Button } from "PFComponents/button";
import { OrderConfig } from "PFTypes/order_config";
import React, { useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { Property } from "../components/property";
import { useFiltersAndOrderConfigContext } from "../filters_and_order_config_context";
import css from "./config_form.module.scss";

export const OrderConfigForm = () => {
  const { t } = useTranslation("saasAdmin", { keyPrefix: "filtersConfig" });
  const { t: tTranslation } = useTranslation();
  const history = useHistory();
  const {
    config: { data: config },
    template: { data: configTemplate },
    handleSubmit: onSubmit,
    handleError: onError
  } = useFiltersAndOrderConfigContext().order;

  const inputs = configTemplate?.inputs || {};

  const defaultValues = useMemo(() => {
    const parsedOptions = (config?.options || []).map((option) => ({
      ...option,
      selected: isEqual(pick(option, "name", "direction"), pick(config?.value, "name", "direction"))
    }));

    return { ...omit(config, "value"), options: parsedOptions };
  }, [config]);

  const methods = useForm<OrderConfig>({
    defaultValues
  });

  const { handleSubmit, reset, setValue, watch } = methods;
  const optionsArray = watch("options");

  // when one option is selected, unselect others
  const handleChange = (name, value) => {
    if (/options\.[0-9]+\.selected/.test(name) && value) {
      optionsArray.forEach((item, index) => {
        if (item.selected && name !== `options.${index}.selected`) {
          setValue(`options.${index}.selected`, false);
        }
      });
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className={css.orderProperties}>
          {Object.keys(inputs).map((key) => (
            <Property
              className={css.orderProperty}
              key={key}
              name={key}
              onChange={handleChange}
              {...inputs[key]}
            />
          ))}
        </div>
        <div className={css.buttons}>
          <Button
            type="button"
            kind="secondary"
            text={tTranslation("cancel")}
            onClick={() => history.push("/saas_admin/accounts")}
          />
          <Button
            type="button"
            kind="secondary"
            text={tTranslation("reset")}
            onClick={() => reset(undefined, { keepDefaultValues: true })}
          />
          <Button type="submit" text={t("submit")} />
        </div>
      </form>
    </FormProvider>
  );
};
